__turbopack_context__.v({
  "checkboxGroupHeading": "publications-search-module-scss-module__Nzq6gq__checkboxGroupHeading",
  "checkboxGroups": "publications-search-module-scss-module__Nzq6gq__checkboxGroups",
  "checkboxSubGroups": "publications-search-module-scss-module__Nzq6gq__checkboxSubGroups",
  "filterCount": "publications-search-module-scss-module__Nzq6gq__filterCount",
  "filterHeading": "publications-search-module-scss-module__Nzq6gq__filterHeading",
  "loading": "publications-search-module-scss-module__Nzq6gq__loading",
  "mainWrapper": "publications-search-module-scss-module__Nzq6gq__mainWrapper",
  "pills": "publications-search-module-scss-module__Nzq6gq__pills",
  "resultCount": "publications-search-module-scss-module__Nzq6gq__resultCount",
  "results": "publications-search-module-scss-module__Nzq6gq__results",
  "resultsCountSection": "publications-search-module-scss-module__Nzq6gq__resultsCountSection",
  "sortByTitle": "publications-search-module-scss-module__Nzq6gq__sortByTitle",
  "sortControl": "publications-search-module-scss-module__Nzq6gq__sortControl",
});
